module.exports = __webpack_public_path__ + "img/steps.2869fc4b.svg";